/**
 * Global namespace for components `fixed-bottom` class.
 */
const fixedBottomClass = "fixed-bottom";
export default fixedBottomClass;
